/* Parc Fermé motion engine v1.1 — lights-out (once/session), scroll reveals, mini rev lights */
(function () {
  function init() {
    document.documentElement.classList.add('pf-motion-ready');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lo = document.getElementById('pf-lightsout');
    if (lo) {
      var played = false;
      try { played = sessionStorage.getItem('pf_lightsout') === '1'; } catch (e) {}
      if (reduced || played) {
        lo.parentNode.removeChild(lo);
      } else {
        try { sessionStorage.setItem('pf_lightsout', '1'); } catch (e) {}
        var lights = lo.querySelectorAll('.pf-glight');
        var txt = lo.querySelector('.txt');
        lights.forEach(function (l, i) { setTimeout(function () { l.classList.add('on'); }, 260 * (i + 1)); });
        setTimeout(function () {
          lights.forEach(function (l) { l.classList.remove('on'); });
          if (txt) txt.textContent = 'AND AWAY WE GO.';
        }, 260 * 6 + 340);
        setTimeout(function () { lo.classList.add('done'); }, 260 * 6 + 900);
        lo.addEventListener('click', function () { lo.classList.add('done'); });
      }
    }
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      document.querySelectorAll('.pf-rv').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.pf-rv').forEach(function (el) { el.classList.add('in'); });
    }
    if (!reduced) {
      document.querySelectorAll('.pf-minilights').forEach(function (group) {
        var lights = group.querySelectorAll('.pf-mlight'); var i = 0;
        setInterval(function () {
          lights.forEach(function (l, idx) { l.classList.toggle('on', idx <= i); });
          i = (i + 1) % (lights.length + 1);
        }, 700);
      });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();